import { deepEqual } from './deep-equal.js';
import {
  canUseDOM,
  contains,
  getOwnerDocument,
  getOwnerWindow,
  isBrowser,
} from './dom.js';
import { logInfo } from './log.js';
import { getFullUrlHref } from './path.js';
import { promiseAllSettled } from './promise.js';
import {
  assignRef,
  createContext,
  getValidChildren,
  mergeRefs,
} from './react-helpers.js';

export const utils = {
  isBrowser,
  canUseDOM,
  contains,
  logInfo,
  deepEqual,
  getOwnerDocument,
  getOwnerWindow,
  assignRef,
  createContext,
  getValidChildren,
  mergeRefs,
  getFullUrlHref,
  promiseAllSettled,
};
